<template>
  <div
    class="audio-item-failure-box"
    :class="{
      [`audio-item-failure-box--${createRenderType}`]: true,
      'audio-item-failure-box-first': props.index == 0,
    }"
  >
    <div class="audio-item-failure">
      <div class="audio-item-box-warning">
        <i class="block"></i>
      </div>
      <div class="audio-item-box-error-text flex1 width-0">
        <span class="block">
          {{
            props.pitem?.state != 10
              ? props.pitem?.state == 11
                ? createRenderType == "mobile"
                  ? $$t("create.generate_failed_melody_mobile")
                  : $$t("create.generate_failed_melody")
                : $$t("create.generate_failed")
              : $$t("create.extend_too_long_generate_failed_feed")
          }}
        </span>
      </div>

      <div class="audio-item-box-btns">
        <div
          class="fn-inline audio-item-box-btn"
          v-if="createRenderType != 'mobile'"
        >
          <Button
            @click="doDelete"
            :renderStyle="{
              '--padding': '0 12px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.delete") }}
          </Button>
        </div>
        <div
          class="fn-inline audio-item-box-btn"
          v-if="createRenderType == 'mobile'"
        >
          <IconButton
            size="32px"
            icoSize="16px"
            backgroundColor="rgb(255, 255, 255, 0.1)"
            hoverBackgroundColor="rgb(255, 255, 255, 0.2)"
            @onClick="doDelete"
          >
            <img src="@/assets/img/close-ico.png" />
          </IconButton>
        </div>
        <div
          class="fn-inline audio-item-box-btn"
          v-if="![10, 11].includes(props.pitem?.state)"
        >
          <Button
            @click="doRetry"
            :loading="renderData.isLoading"
            :renderStyle="{
              '--padding': '0 12px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.retry") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import IconButton from "@/components/basic/button/IconButton.vue";
import Button from "@/components/basic/button/Button.vue";
import LoaderCircle from "@/components/animation/LoaderCircle.vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult
  },
});

const emits = defineEmits(["delete", "retry", "from"]);

const renderData = reactive({
  isLoading: false,
});

const doDelete = () => {
  emits("delete", props.pitem);
};

const doRetry = () => {
  emits("retry", props.pitem, null, (isLoading) => {
    renderData.isLoading = isLoading;
  });
};

const doFrom = () => {
  emits("from", props.pitem);
};

onMounted(() => {});
</script>
<style lang="scss" scope>
.audio-item-failure-box {
  padding: 6px 20px;
  // &:hover {
  // background: rgba(255, 255, 255, 0.1);
  //}
  &.audio-item-failure-box-first {
    padding-top: 12px;
  }
  .audio-item-failure {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-radius: 12px;
    background: rgb(255, 95, 116, 0.15);
    backdrop-filter: blur(20px);
    justify-content: space-between;
  }

  .audio-item-box-error-text {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    min-height: 24px;
    color: #fff;
    padding: 0 0 0 8px;
    display: flex;
    align-items: center;
  }
  .audio-item-box-btn {
    margin-left: 8px;
  }
  .audio-item-box-warning {
    height: 24px;
    width: 24px;
    i {
      height: 24px;
      width: 24px;
      filter: grayscale(0.45);
      background: url("@/assets/img/circle-warning-ico.png");
      background-size: 100% 100%;
    }
  }
  &.audio-item-failure-box--mobile {
    padding: 12px 16px 12px 20px;
    .audio-item-failure {
      padding: 10px 12px;
    }
    .audio-item-box-error-text {
      font-size: 14px;
      line-height: 18px;
      span {
        white-space: break-spaces;
      }
    }
  }
}
</style>
